export default __webpack_public_path__ + "static/media/nen.e3699c12.png";